<template>
    <div class="main">
        <el-main>
            <!-- 路由占位符 -->
            <router-view></router-view>
        </el-main>
    </div>
</template>
<script>
export default {
    name:"MainView",
    data(){
        return {

        }
    },
    created() {

    },
    methods:{

    }
}
</script>
<style scoped>
  /* 主区域 */
.main {
    /* width: 1000px; */
    position: absolute;
    top: 60px;
    left: 200px;
    bottom: 0px;
    right: 0px;  /* 距离右边0像素 */
    overflow-y: auto; /* 当内容过多时y轴出现滚动条 */
    background-color: #fff;
}
</style>
